import rectangle from 'utils/rectangle.js'

let is_dragging = false, is_rotating = false, is_scaling = false
let originalX = 0, originalY = 0, startX = 0, startY = 0, startW = 0, startH = 0, centerX = 0, centerY = 0

function getCompById(state, id) {
	return (state.canvas || []).findIndex(item => item.id === id)
}

export function elm_click({ commit, dispatch, state }, { id, event }) {
	dispatch('elm_select', { id })
	dispatch('elm_start_drag', { id, event })
}

export function elm_start_drag({ commit, dispatch, state }, { id, event }) {

	commit('update', {
		moving: true
	})
	is_dragging = true
	originalX = event.clientX
	originalY = event.clientY
	startX = state.selected.x
	startY = state.selected.y
	centerX = state.selected.center.x
	centerY = state.selected.center.y
	document.on('mousemove.move', function (event) {
		if (!is_dragging) return
		let deltaX = event.clientX - originalX
		let deltaY = event.clientY - originalY
		deltaX = Math.floor(deltaX * 10) / 10
		deltaY = Math.floor(deltaY * 10) / 10
		let x = Math.floor(startX + deltaX / state.scaleRate)
		let y = Math.floor(startY + deltaY / state.scaleRate)
		commit('update_elm', {
			id,
			data: {
				x,
				y
			}
		})
		commit('update_selected', {
			x,
			y,
			center: {
				x: centerX + deltaX,
				y: centerY + deltaY
			}
		})

		// 拖拽组件时刻度线计算
		// let a = new Date().getTime()
		// localStorage.setItem('action-start',a)
		let sources = [],
			targets = [],
			chunkSources = [],
			chunkTargets = []
		sources = rectangle.getPoint(state.selected)
		chunkSources = [
			[(Math.round(sources[2][0] + Math.abs(sources[1][0] - sources[2][0]) / 2)), Math.round(sources[2][1] + Math.abs((sources[3][1] - sources[2][1]) / 2))],
			[(Math.round(sources[2][0] + Math.abs(sources[1][0] - sources[2][0]) / 2)), sources[2][1]],
			sources[2],
			[sources[2][0], Math.round(sources[2][1] + Math.abs((sources[3][1] - sources[2][1]) / 2))]
		]
		let w = state.designWidth
		let h = state.designHeight
		chunkTargets = [[
			[w, h],
			[w, Math.round(h / 2)],
			[0, Math.round(h / 2)],
			[0, h],
		]]
		chunkTargets.push([
			[w, h],
			[w, 0],
			[Math.round(w / 2), 0],
			[Math.round(w / 2), h],
		])
		state.canvas.forEach(item => {
			if (item.id !== state.selected.id) {
				let temp = rectangle.getPoint(item)
				targets.push(temp)
			}
		})
		targets = targets.concat(chunkTargets)

		// console.log(sources, targets, chunkSources, chunkTargets)

		let lines = rectangle.intersectLine(sources, targets) || []

		let chuckLines = rectangle.intersectLine(chunkSources, chunkTargets) || []
		lines = lines.concat(chuckLines)
		// console.log(lines, chuckLines)
		commit('update', {
			positionList: lines
		})

		// console.log('---计算over--',new Date().getTime(), '相差:', new Date().getTime()-a)
		// localStorage.setItem('action-over' ,new Date().getTime()-a)
		// localStorage.setItem('action-over-time' ,new Date().getTime())


		event.stopPropagation()
	})

	document.on('mouseup.move', function (event) {
		is_dragging = false
		commit('update', {
			moving: false
		})
		document.off('mousemove.move')
		document.off('mouseup.move')

		if (event.clientX - originalX || event.clientY - originalY) {
			commit('push_history', {
				canvas: state.canvas
			})
		}
		commit('update', {
			positionList: []
		})
		event.stopPropagation()
	})
}

export function elm_start_rotate({ commit, dispatch, state }, { id }) {
	is_rotating = true
	commit('update', {
		rotating: true
	})
	document.on('mousemove.rotate', function (event) {
		if (!is_rotating) return
		const center = state.selected.center
		const deltaX = event.clientX - center.x
		const deltaY = event.clientY - center.y
		const k = deltaX / Math.abs(deltaX)
		let rotate = Math.atan(deltaY / deltaX) / Math.PI * 180 + 90 * k
		rotate = Math.floor(rotate * 10) / 10
		if (Number.isNaN(rotate)) rotate = 0
		commit('update_elm', {
			id,
			data: {
				rotate
			}
		})
		commit('update_selected', {
			rotate
		})
		event.stopPropagation()
	})
	document.on('mouseup.rotate', function (event) {
		is_rotating = false
		commit('update', {
			rotating: false
		})
		document.off('mousemove.rotate')
		document.off('mouseup.rotate')

		commit('push_history', {
			canvas: state.canvas
		})
		event.stopPropagation()
	})
}


export function elm_start_scale({ commit, dispatch, state }, { id, event, type }) {
	is_scaling = true
	originalX = event.clientX
	originalY = event.clientY
	startX = state.selected.x
	startY = state.selected.y
	startW = state.selected.width
	startH = state.selected.height
	centerX = state.selected.center.x
	centerY = state.selected.center.y
	document.on('mousemove.scale', function (ev) {
		if (!is_scaling) return
		const selected = state.selected
		const angle = selected.rotate / 180 * Math.PI
		const dot = (ev.clientX - originalX) * (centerX - originalX) + (ev.clientY - originalY) * (centerY - originalY)
		const origin = Math.sqrt(Math.pow(originalX - centerX, 2) + Math.pow(originalY - centerY, 2))
		const delta = (-dot > 0 ? 1 : -1) * Math.abs(dot / origin) / state.scaleRate
		const sin = selected.width / Math.sqrt(Math.pow(selected.width, 2) + Math.pow(selected.height, 2))
		const cos = selected.height / Math.sqrt(Math.pow(selected.width, 2) + Math.pow(selected.height, 2))
		let width, height, x, y

		if (type === 'n') {
			width = startW
			height = startH + delta
			x = startX + delta / 2 * Math.sin(angle)
			y = startY - delta / 2 * Math.cos(angle)
		} else if (type === 's') {
			width = startW
			height = startH + delta
			x = startX - delta / 2 * Math.sin(angle)
			y = startY + delta / 2 * Math.cos(angle)
		} else if (type === 'e') {
			width = startW + delta
			height = startH
			x = startX + delta / 2 * Math.cos(angle)
			y = startY + delta / 2 * Math.sin(angle)
		} else if (type === 'w') {
			width = startW + delta
			height = startH
			x = startX - delta / 2 * Math.cos(angle)
			y = startY - delta / 2 * Math.sin(angle)
		} else {
			width = startW + delta * sin
			height = startH + delta * cos
			if (type === 'ne') {
				x = startX + delta / 2 * cos * Math.sin(angle) + delta / 2 * sin * Math.cos(angle)
				y = startY - delta / 2 * cos * Math.cos(angle) + delta / 2 * sin * Math.sin(angle)
			} else if (type === 'nw') {
				x = startX + delta / 2 * cos * Math.sin(angle) - delta / 2 * sin * Math.cos(angle)
				y = startY - delta / 2 * cos * Math.cos(angle) - delta / 2 * sin * Math.sin(angle)
			} else if (type === 'se') {
				x = startX - delta / 2 * cos * Math.sin(angle) + delta / 2 * sin * Math.cos(angle)
				y = startY + delta / 2 * cos * Math.cos(angle) + delta / 2 * sin * Math.sin(angle)
			} else if (type === 'sw') {
				x = startX - delta / 2 * cos * Math.sin(angle) - delta / 2 * sin * Math.cos(angle)
				y = startY + delta / 2 * cos * Math.cos(angle) - delta / 2 * sin * Math.sin(angle)
			}
		}
		ev.stopPropagation()

		if (width < 30 || height < 30 || !height || !width) {
			return
		}
		//center 未改变
		commit('update_selected', {
			width,
			height,
			x,
			y
		})
		commit('update_elm', {
			id,
			data: {
				width,
				height,
				x,
				y
			}
		})

	})
	document.on('mouseup.scale', function (event) {
		is_scaling = false
		document.off('mousemove.scale')
		document.off('mouseup.scale')

		commit('push_history', {
			canvas: state.canvas
		})
		event.stopPropagation()
	})
}

export function elm_start_edit_text({ commit, dispatch, state }, { id }) {
	const elm = document.getElementById(id)
	elm.style.display = 'none'
	commit('update', {
		editing: id
	})
}

export function elm_complete_edit_text({ commit, dispatch, state }, { data }) {
	commit('update_elm', {
		id: state.editing,
		data: data
	})
	document.getElementById(state.editing).style.display = 'block'

	commit('update', {
		editing: false
	})
	dispatch('elm_unselect')
	commit('push_history', {
		canvas: state.canvas
	})
}

export function elm_select({ commit, dispatch, state }, { id }) {
	const compIndex = getCompById(state, id)
	const bbox = document.getElementById(id).getBoundingClientRect()
	const comp = state.canvas[compIndex]
	if (comp) {
		const { id, x, y, width, height, type } = comp
		if (state.editing && id !== state.editing) {
			document.getElementById(state.editing).style.display = 'block'
		}
		commit('update_selected', {
			id,
			x,
			y,
			width,
			height,
			type,
			center: {
				x: bbox.left + bbox.width / 2,
				y: bbox.top + bbox.height / 2
			},
			style: comp.style || {},
			content: comp.content,
			rotate: comp.rotate,
			isDynamic: comp.isDynamic,
			isCover: comp.isCover,
			zIndex: compIndex * 10 + 1
		})
	}
}

export function elm_unselect({ commit, state }) {
	if (state.editing) {
		return false
	}
	if (state.selected && state.selected.id) {
		commit('update', {
			selected: {}
		})
	}
}

export function elm_add({ commit, state }, payload) {
	const list = state.canvas || []
	list.push({
		id: Math.random(),
		rotate: 0,
		...payload
	})
	commit('update', {
		canvas: list
	})
	commit('push_history', {
		canvas: list
	})
}



export function action_start_drag({ commit, dispatch, state, rootState }, { id, event }) {
	commit('update', {
		moving: true
	})
	is_dragging = true
	originalX = event.clientX
	originalY = event.clientY
	startX = state.selected.x
	startY = state.selected.y
	centerX = state.selected.center.x
	centerY = state.selected.center.y
	document.on('mousemove.move', function (event) {
		if (!is_dragging) return
		let deltaX = event.clientX - originalX
		let deltaY = event.clientY - originalY
		deltaX = Math.floor(deltaX * 10) / 10
		deltaY = Math.floor(deltaY * 10) / 10
		let x = Math.floor(startX + deltaX / state.scaleRate)
		let y = Math.floor(startY + deltaY / state.scaleRate)
		commit('update_elm', {
			id,
			data: {
				x,
				y
			}
		})
		commit('update_selected', {
			x,
			y,
			center: {
				x: centerX + deltaX,
				y: centerY + deltaY
			}
		})

		const act = rootState.actions.find(item => item.element + '_' + item.name === id)
		const { width, height } = rootState.selected
		const pos = `${x / rootState.designWidth},${y / rootState.designHeight},${(x + width) / rootState.designWidth},${(y + height) / rootState.designHeight}`
		commit('update_action', {
			name: act.name,
			startPos: pos,
			endPos: pos
		})

		event.stopPropagation()
	})

	document.on('mouseup.move', function (event) {
		is_dragging = false
		commit('update', {
			moving: false
		})
		document.off('mousemove.move')
		document.off('mouseup.move')
		event.stopPropagation()
	})
}